// Tipos de documentos por contexto
export const DOCUMENTOS_ENCARGOS = [
	{ value: 'ANEXO_COMPROMISO_DE_VENTA', label: 'Anexo Compromiso de Venta' },
	{ value: 'COMPROMISO_DE_VENTA', label: 'Compromiso de Venta' },
	{ value: 'GASTOS_VENDEDOR', label: 'Gastos Vendedor' },
	{ value: 'RECISION_DE_CONTRATO', label: 'Rescisión de Contrato' },
];

export const DOCUMENTOS_PEDIDOS = [
	{ value: 'HOJA_DE_VISITA', label: 'Hoja de Visita' },
	{
		value: 'CONTRATOINTERMEDACIONWOLFIN',
		label: 'Contrato de Intermediación',
	},
	{ value: 'DECLARACION_DE_COMISION', label: 'Declaración de Comisión' },
	{ value: 'GASTOS_COMPRADOR', label: 'Gastos Comprador' },
	{ value: 'PROPUESTA_DE_COMPRAVENTA', label: 'Propuesta de Compraventa' },
	{
		value: 'RECONOCIMIENTO_DE_HONORARIOS',
		label: 'Reconocimiento de Honorarios',
	},
];

// Tipos que requieren autofill
export const TIPOS_CON_AUTOFILL = [
	'HOJA_DE_VISITA',
	'ANEXO_COMPROMISO_DE_VENTA',
	'COMPROMISO_DE_VENTA',
	'CONTRATOINTERMEDACIONWOLFIN',
	'DECLARACION_DE_COMISION',
	'GASTOS_VENDEDOR',
	'GASTOS_COMPRADOR',
	'RECISION_DE_CONTRATO',
	'PROPUESTA_DE_COMPRAVENTA',
	'RECONOCIMIENTO_DE_HONORARIOS',
];
